export function createSlotZonesBetweenPillar(params) {
    const { sizes, maps: pillars, sizeBoard } = params;
    const pillarW = sizeBoard.w;
    const pillarH = sizeBoard.h;
    const slotHeight = sizeBoard.l;
    const halfDepth = sizes.w / 2;
    const centerY = slotHeight / 2;
    const slots = [];
    // ─── Боковые стены (вдоль X) ──────────────────────────────────────────────
    for (let i = 0; i < pillars.length - 1; i++) {
        const x1 = pillars[i][0];
        const x2 = pillars[i + 1][0];
        const leftOffset = i === 0 ? pillarW : pillarW / 2;
        const rightOffset = i === pillars.length - 2 ? pillarW : pillarW / 2;
        const xStart = x1 + leftOffset;
        const xEnd = x2 - rightOffset;
        const slotWidth = xEnd - xStart;
        const centerX = (xStart + xEnd) / 2;
        // Передняя — смотрит наружу в +Z
        slots.push({
            id: `${params.id}-wall-front-${i}`,
            type: 'wall',
            width: slotWidth,
            height: slotHeight,
            depth: pillarW,
            position: [centerX, centerY, halfDepth],
            rotation: [0, 0, 0],
        });
        // Задняя — смотрит наружу в -Z, разворот на 180°
        slots.push({
            id: `${params.id}-wall-back-${i}`,
            type: 'wall',
            width: slotWidth,
            height: slotHeight,
            depth: pillarW,
            position: [centerX, centerY, -halfDepth],
            rotation: [0, Math.PI, 0],
        });
    }
    // ─── Торцевые стены (вдоль Z) ─────────────────────────────────────────────
    const firstX = pillars[0][0];
    const lastX = pillars[pillars.length - 1][0];
    const slotDepth = sizes.w - pillarH * 2;
    // Левый торец — смотрит наружу в -X
    slots.push({
        id: `${params.id}-wall-end-left`,
        type: 'wall',
        width: slotDepth,
        height: slotHeight,
        depth: pillarW,
        position: [firstX, centerY, 0],
        rotation: [0, -Math.PI / 2, 0],
    });
    // Правый торец — смотрит наружу в +X
    slots.push({
        id: `${params.id}-wall-end-right`,
        type: 'wall',
        width: slotDepth,
        height: slotHeight,
        depth: pillarW,
        position: [lastX, centerY, 0],
        rotation: [0, Math.PI / 2, 0],
    });
    // ─── Пол ──────────────────────────────────────────────────────────────────
    const floorWidth = lastX - firstX - pillarW * 2;
    const floorDepth = sizes.w - pillarH * 2;
    const floorCenterX = (firstX + lastX) / 2;
    slots.push({
        id: `${params.id}-floor`,
        type: 'floor',
        width: floorWidth,
        height: floorDepth,
        depth: pillarW,
        position: [floorCenterX, 0, 0],
        rotation: [-Math.PI / 2, 0, 0],
    });
    return slots;
}
